import { useMutation } from "react-query";
import { updateEducationHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpdateEducationHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ id, payload }: { id: number; payload: Record<string, any> }) =>
      updateEducationHistory(id, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while updating the education history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    updateEducationHistoryMutation: mutate,
    isUpdateEducationHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpdateEducationHistory;
